$(document).ready(function(){
  $('.trusted-teams').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    adaptiveHeight: true,
    prevArrow: '.multicolumn-arrow.prev',
    nextArrow: '.multicolumn-arrow.next',
    dragable: true,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
});